import { cn as e } from "../cn.js";
import { Select as t } from "../forms/select/index.js";
import { Button as n } from "../button/index.js";
import { InputText as r } from "../forms/input-text/index.js";
import { getStyles as i } from "./style.js";
import * as a from "react";
import { useState as o } from "react";
import { ChevronLeft as s, ChevronRight as c, ChevronsLeft as l, ChevronsRight as u, MoreHorizontal as d } from "lucide-react";
import { Fragment as f, jsx as p, jsxs as m } from "react/jsx-runtime";
import { Pagination as h } from "@ark-ui/react/pagination";
// src/design/pagination/Pagination.tsx
var g = a.createContext({
	variant: "default",
	size: "md"
}), _ = () => a.useContext(g), v = ({ className: t, variant: n = "default", size: r = "md", children: a, ...o }) => {
	let s = i({
		variant: n,
		size: r
	});
	return /* @__PURE__ */ p(g.Provider, {
		value: {
			variant: n,
			size: r
		},
		children: /* @__PURE__ */ p(h.Root, {
			...o,
			children: /* @__PURE__ */ p(h.Context, { children: (i) => /* @__PURE__ */ p("nav", {
				role: "navigation",
				"aria-label": "Pagination Navigation",
				className: e("flex items-center justify-center", s.gap(), t),
				"data-variant": n,
				"data-size": r,
				children: typeof a == "function" ? a(i) : a
			}) })
		})
	});
}, y = ({ variant: e, size: t, ...n }) => {
	let r = _(), a = e ?? r.variant, o = t ?? r.size, s = i({
		variant: a,
		size: o
	});
	return /* @__PURE__ */ p(h.Context, { children: (e) => {
		let t = e.page === n.value;
		return /* @__PURE__ */ p(h.Item, {
			...n,
			className: s.button({ active: t }),
			children: n.value
		});
	} });
}, b = ({ variant: e, size: t, ...n }) => {
	let r = _(), a = e ?? r.variant, o = t ?? r.size, s = i({
		variant: a,
		size: o
	});
	return /* @__PURE__ */ p(h.Ellipsis, {
		...n,
		className: s.ellipsis(),
		children: /* @__PURE__ */ p(d, { className: "h-4 w-4" })
	});
}, x = ({ variant: t, size: n, className: r }) => {
	let a = _(), o = t ?? a.variant, c = n ?? a.size, l = i({
		variant: o,
		size: c
	});
	return /* @__PURE__ */ p(h.PrevTrigger, {
		className: e(l.button(), r),
		children: /* @__PURE__ */ p(s, { className: "h-4 w-4" })
	});
}, S = ({ variant: t, size: n, className: r }) => {
	let a = _(), o = t ?? a.variant, s = n ?? a.size, l = i({
		variant: o,
		size: s
	});
	return /* @__PURE__ */ p(h.NextTrigger, {
		className: e(l.button(), r),
		children: /* @__PURE__ */ p(c, { className: "h-4 w-4" })
	});
}, C = ({ options: n = [
	10,
	20,
	50,
	100
], className: r }) => (_(), /* @__PURE__ */ p(h.Context, { children: (i) => {
	let a = n.map((e) => ({
		label: `${e} rows per page`,
		value: String(e)
	})), o = {
		label: `${i.pageSize} rows per page`,
		value: String(i.pageSize)
	};
	return /* @__PURE__ */ p("div", {
		className: e("flex items-center gap-2", r),
		children: /* @__PURE__ */ p(t, {
			options: a,
			value: o,
			onChange: (e) => {
				e.value && !Array.isArray(e.value) && i.setPageSize(Number(e.value.value));
			},
			showClearButton: !1
		})
	});
} })), w = ({ className: t, label: i = "Go to", buttonText: a = "Go" }) => {
	_();
	let [s, c] = o("");
	return /* @__PURE__ */ p(h.Context, { children: (o) => /* @__PURE__ */ m("form", {
		onSubmit: (e) => {
			e.preventDefault();
			let t = Number(s);
			t >= 1 && t <= o.totalPages && (o.setPage(t), c(""));
		},
		className: e("flex items-center gap-2", t),
		children: [
			/* @__PURE__ */ p("label", {
				htmlFor: "goto-page",
				className: "text-xs text-muted-foreground whitespace-nowrap",
				children: i
			}),
			/* @__PURE__ */ p(r, {
				id: "goto-page",
				type: "number",
				min: 1,
				max: o.totalPages,
				value: s,
				onChange: (e) => c(e.target.value),
				placeholder: `1-${o.totalPages}`,
				config: { size: "sm" },
				"aria-label": "Go to page number"
			}),
			/* @__PURE__ */ p(n, {
				type: "submit",
				variant: "secondary",
				size: "sm",
				"aria-label": "Go to page",
				children: a
			})
		]
	}) });
}, T = ({ showItems: t = !0, showPages: n = !0, className: r }) => /* @__PURE__ */ p(h.Context, { children: (i) => {
	let a = (i.page - 1) * i.pageSize + 1, o = Math.min(i.page * i.pageSize, i.count);
	return /* @__PURE__ */ m("div", {
		className: e("text-xs text-muted-foreground", r),
		children: [t && i.count > 0 && /* @__PURE__ */ m("span", { children: [
			/* @__PURE__ */ m("span", {
				className: "font-medium text-foreground",
				children: [
					a.toLocaleString(),
					" - ",
					o.toLocaleString(),
					" of",
					" ",
					i.count.toLocaleString()
				]
			}),
			" ",
			/* @__PURE__ */ p("span", { children: "items" })
		] }), n && /* @__PURE__ */ m("span", {
			className: t && i.count > 0 ? "ml-4 font-medium text-foreground" : "font-medium text-foreground",
			children: [
				"Page ",
				i.page,
				" of ",
				i.totalPages
			]
		})]
	});
} }), E = ({ variant: e, size: t }) => {
	let n = _(), r = e ?? n.variant, i = t ?? n.size;
	return /* @__PURE__ */ p(h.Context, { children: (e) => /* @__PURE__ */ p(f, { children: e.pages.map((e, t) => e.type === "page" ? /* @__PURE__ */ p(y, {
		...e,
		variant: r,
		size: i
	}, t) : /* @__PURE__ */ p(b, {
		index: t,
		variant: r,
		size: i
	}, `ellipsis-${t}`)) }) });
}, D = ({ showInfo: t = !1, showPageSize: n = !1, showGoTo: r = !1, pageSizeOptions: a, infoPosition: o = "bottom", showFirstLast: s = !0, variant: c = "default", size: d = "md", className: f, ...g }) => {
	let _ = i({
		variant: c,
		size: d
	});
	return /* @__PURE__ */ p(v, {
		...g,
		variant: c,
		size: d,
		children: (i) => {
			let c = t ? /* @__PURE__ */ p(T, { className: o === "left" || o === "right" ? "flex-shrink-0" : void 0 }) : null, d = /* @__PURE__ */ m("nav", {
				role: "navigation",
				"aria-label": "Pagination Navigation",
				className: e("flex items-center justify-center", _.gap(), f),
				children: [
					s && /* @__PURE__ */ p(h.Item, {
						type: "page",
						value: 1,
						className: _.button(),
						children: /* @__PURE__ */ p(l, { className: "h-4 w-4" })
					}),
					/* @__PURE__ */ p(x, {}),
					/* @__PURE__ */ p(E, {}),
					/* @__PURE__ */ p(S, {}),
					s && /* @__PURE__ */ p(h.Item, {
						type: "page",
						value: i.totalPages,
						className: _.button(),
						children: /* @__PURE__ */ p(u, { className: "h-4 w-4" })
					})
				]
			}), g = n || r ? /* @__PURE__ */ m("div", {
				className: "flex items-center gap-4 flex-wrap",
				children: [r && /* @__PURE__ */ p(w, {}), n && /* @__PURE__ */ p(C, { options: a })]
			}) : null;
			return !t && !g ? d : o === "top" ? /* @__PURE__ */ m("div", {
				className: "space-y-3",
				children: [
					c,
					g,
					d
				]
			}) : o === "bottom" ? /* @__PURE__ */ m("div", {
				className: "space-y-3",
				children: [
					d,
					g,
					c
				]
			}) : o === "left" ? /* @__PURE__ */ m("div", {
				className: "flex items-center gap-4 flex-wrap",
				children: [
					c,
					d,
					g
				]
			}) : o === "right" ? /* @__PURE__ */ m("div", {
				className: "flex items-center gap-4 flex-wrap",
				children: [
					d,
					g,
					c
				]
			}) : /* @__PURE__ */ m("div", {
				className: "space-y-3",
				children: [
					d,
					g,
					c
				]
			});
		}
	});
}, O = ({ variant: e = "simple", size: t = "md", ...n }) => /* @__PURE__ */ m(v, {
	...n,
	variant: e,
	size: t,
	children: [
		/* @__PURE__ */ p(x, {}),
		/* @__PURE__ */ p(T, { showItems: !1 }),
		/* @__PURE__ */ p(S, {})
	]
}), k = ({ variant: e = "compact", size: t = "md", siblingCount: n = 0, ...r }) => /* @__PURE__ */ m(v, {
	...r,
	variant: e,
	size: t,
	siblingCount: n,
	children: [
		/* @__PURE__ */ p(x, {}),
		/* @__PURE__ */ p(E, {}),
		/* @__PURE__ */ p(S, {})
	]
}), A = Object.assign(D, {
	Root: v,
	Item: y,
	Pages: E,
	Ellipsis: b,
	PrevTrigger: x,
	NextTrigger: S,
	Info: T,
	PageSizeSelect: C,
	GoToPageInput: w,
	Simple: O,
	Compact: k
});
export { k as CompactPagination, w as GoToPageInput, C as PageSizeSelect, D as Pagination, b as PaginationEllipsis, T as PaginationInfo, y as PaginationItem, S as PaginationNextTrigger, E as PaginationPages, x as PaginationPrevTrigger, v as PaginationRoot, O as SimplePagination, A as default };

//# sourceMappingURL=Pagination.js.map